/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcQuotemediaV1Sp500ListEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_QUOTEMEDIA_V1_SP500_LIST_EVENT_ENTITY_NAME = 'exc.quotemedia.v1.Sp500ListEvent';
export const excQuotemediaV1Sp500ListEventEntity = new schema.Entity<ExcQuotemediaV1Sp500ListEvent>(EXC_QUOTEMEDIA_V1_SP500_LIST_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcQuotemediaV1Sp500ListEvent) => `${entity.metadata?.eventId}` });

